import { GovOpsApiError, GovOpsAuthError } from './govopsClient';
import { GOVOPS_ENTITLEMENT_MSG, GovOpsEntitlementRequiredError } from './govopsExceptions';
import { formatStatus } from '../constants/workflowLabels';

export { GOVOPS_ENTITLEMENT_MSG, GovOpsEntitlementRequiredError };

function formatInvalidTransitionMessage(raw) {
  const text = String(raw || '');
  const match = text.match(/(?:invalid_govops_transition:)?([a-z_]+)->([a-z_]+)/i);
  if (!match) return null;
  const [, from, to] = match;
  return (
    `Cannot change status from "${formatStatus(from)}" to "${formatStatus(to)}". ` +
    'Choose a valid next step in the status dropdown.'
  );
}

/** User-facing message for GovOps API failures. */
export function formatGovOpsError(err) {
  if (!err) return 'Request failed. Please try again.';
  if (err instanceof GovOpsEntitlementRequiredError) return GOVOPS_ENTITLEMENT_MSG;
  if (err instanceof GovOpsAuthError) {
    return err.message || 'Please sign in to use permit operations.';
  }
  if (err instanceof GovOpsApiError) {
    if (err.status === 403) {
      return (
        'GovOps access denied. Your account needs the govops entitlement on SD Panthers ' +
        '(same Firebase user ID as RobinhoodSpace login).'
      );
    }
    if (err.status === 401) return 'Session expired. Please sign out and sign in again.';
    if (err.status === 400) {
      const detail = err.body?.message || err.message;
      const transitionMsg = formatInvalidTransitionMessage(detail);
      if (transitionMsg) return transitionMsg;
      return detail ? `Invalid request: ${detail}` : 'Invalid request. Check required fields.';
    }
    if (err.status >= 500) return 'GovOps service is temporarily unavailable. Try again shortly.';
    return err.message || 'GovOps request failed.';
  }
  return err.message || 'Request failed. Please try again.';
}

export function isGovOpsAuthError(err) {
  return (
    err instanceof GovOpsAuthError ||
    err instanceof GovOpsEntitlementRequiredError ||
    err?.name === 'GovOpsAuthError' ||
    err?.name === 'GovOpsEntitlementRequiredError' ||
    (err instanceof GovOpsApiError && (err.status === 401 || err.status === 403))
  );
}
